import { VisionLinkHealthDataProp } from '../../../../types';
import { CatHeading } from '@blocks-react/components/Heading';
import { CatStatusIndicator } from '@blocks-react/components/StatusIndicator';
import styles from '../../../../VisionLink.module.scss';

export const LowSeverity = ({ children }: VisionLinkHealthDataProp) => {
  return (
    <div className="d-flex mt-1">
      <CatStatusIndicator
        className={`${styles['vision-link-severity-icon']} d-flex align-items-center`}
        type="bare"
      />
      <CatHeading variant="footnote">{children}</CatHeading>
    </div>
  );
};
